import React from "react";
import portfolio from "../../assets/home/portfolio2.png";
import { useTranslation } from "react-i18next";
import Skill from "./Skill";
import {
  SKILL_ADVANCED,
  SKILL_BASIC,
  SKILL_GOOD,
} from "../../constants/skills.constants";

const Skills = () => {
  const { t } = useTranslation();
  return (
    <section className="skills" id="skills">
      <div className="container">
        <div className="invitation-github">
          {t("about.ignite")} <i className="far fa-smile-wink smile"></i> <br />
          <a className="about__link" href="https://github.com/szkapec">
            {" "}
            <i className="fab fa-github" data-aos="flip-up"></i>
          </a>
        </div>
        <h2>{t("stos.skills")}</h2>
        <img src={portfolio} className="skills-portfolio" alt="portfolio" />
        <div className="technologies">{t("stos.stos")}</div>
        <h3 className="advanced-skills">{t("stos.advanced")}</h3>
        <article className="article-advanced-skills">
          {t("skills", { returnObjects: true }) && t("skills", { returnObjects: true })?.map((skill) => {
            return (
              skill.group === SKILL_ADVANCED && (
                <Skill key={skill.id} skill={skill} />
              )
            );
          })}
        </article>

        <h3 className="good-skills">{t("stos.good")}</h3>
        <article className="article-good-skills">
          {t("skills", { returnObjects: true }) && t("skills", { returnObjects: true })?.map((skill) => {
            return (
              skill.group === SKILL_GOOD && (
                <Skill key={skill.id} skill={skill} />
              )
            );
          })}
        </article>
        <h3 className="basic-skills">{t("stos.basic")}</h3>
        <article className="acticle-basic-skills">
          {t("skills", { returnObjects: true }) && t("skills", { returnObjects: true })?.map((skill) => {
            return (
              skill.group === SKILL_BASIC && (
                <Skill key={skill.id} skill={skill} />
              )
            );
          })}
        </article>
      </div>
    </section>
  );
};

export default Skills;
